(function () {
    const INIT_FLAG = "mbSustenabilityDeepInit";

    function toNumber(value, fallback) {
        const n = Number(value);
        return Number.isFinite(n) ? n : fallback;
    }

    function applyState(root, expanded) {
        const cards = Array.from(root.querySelectorAll("[data-deep-card]"));
        const toggle = root.querySelector("[data-deep-toggle]");
        const expandLabel = toggle ? toggle.querySelector("[data-label-expand]") : null;
        const collapseLabel = toggle ? toggle.querySelector("[data-label-collapse]") : null;

        const collapsedCount = Math.max(1, toNumber(root.dataset.collapsedCount, 1));
        const canCollapse = cards.length > collapsedCount;

        if (toggle) {
            toggle.hidden = !canCollapse;
            toggle.setAttribute("aria-expanded", expanded ? "true" : "false");
        }

        if (expandLabel) expandLabel.hidden = expanded;
        if (collapseLabel) collapseLabel.hidden = !expanded;

        cards.forEach((card, index) => {
            if (!canCollapse) {
                card.hidden = false;
                return;
            }
            card.hidden = !expanded && index >= collapsedCount;
        });
    }

    function initDeepSection(root) {
        if (!root || root.dataset[INIT_FLAG] === "1") return;
        root.dataset[INIT_FLAG] = "1";

        const defaultExpanded = (root.dataset.expandedDefault || "false") === "true";
        let isExpanded = defaultExpanded;

        applyState(root, isExpanded);

        root.addEventListener("click", function (event) {
            const toggle = event.target.closest("[data-deep-toggle]");
            if (!toggle || !root.contains(toggle)) return;

            isExpanded = !isExpanded;
            applyState(root, isExpanded);
        });
    }

    function initAll(scope) {
        scope.querySelectorAll("[data-mb-sustenability-deep]").forEach(initDeepSection);
    }

    document.addEventListener("DOMContentLoaded", function () {
        initAll(document);
    });

    document.addEventListener("shopify:section:load", function (event) {
        initAll(event.target);
    });
})();
